export default __webpack_public_path__ + "static/media/smartstudio-footer-logo.4178fef8.svg";